import {useEffect} from 'react'
import type {To} from 'react-router'
import {useNavigate} from 'react-router'

type Props = {
  to: To
  replace?: boolean
  state?: unknown
}
export default function Redirect({to, replace = true, state}: Props) {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(to, {replace, state})
  })
  return null
}
